import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
	{
		path: '',
		//
		loadChildren: () => import('./modules/ai.module').then((module) => module.AiModule),
	},
	{
		path: 'ai-survey',
		//
		loadChildren: () => import('./modules/ai-survey/ai-survey.module').then((module) => module.AiSurveyModule),
	},
	{ path: '404', component: PageNotFoundComponent },
	{ path: '**', pathMatch: 'full', redirectTo: '/' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking' })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
